import globalStyle from '../../styles/common.module.css'
import { PagesQuery } from '../../util/types';
import style from './pages.module.css'

export function Endpage({data}: {data: PagesQuery["pages"][number] | undefined}) {
   if (!data) {
     return null
   }
  return (
    <div className={[globalStyle.grid10, globalStyle.gridCenter].join(' ')}>

      <div className={globalStyle.grid6}>
        <h1 className={[globalStyle.heading1, style.header].join(' ')}> {data.title} </h1>
        {
          data.blurb && 
        <div className={globalStyle.bodyLG} dangerouslySetInnerHTML={{ __html: data.blurb.html }} />
        }
      </div>

      <div className={[globalStyle.gridFlex, style.cards].join(' ')}>
        {
          data.links.map((item, i) => {
            return (
              <div className={style.card} key={`linkcard-${i}`}>
                <div>
                  <h2 className={[globalStyle.heading2, globalStyle.fontEggplant, style.cardHeading].join(' ')}> {item.title} </h2>
                  <p className={globalStyle.bodySM}> {item.blurb} </p>
                </div>
                <div>
                  <img className={style.cardImage} src={`assets/icons/scribble-${i%3}.svg`} alt='decorative scribble'/>
                  <a 
                    href={item.url} 
                    target='_blank' 
                    rel='noopener noreferrer' 
                    className={[globalStyle.button, globalStyle.buttonSM, globalStyle.right, style.cardButton].join(' ')}
                  > {item.buttonText || 'Go to guide'} </a>
                </div>
              </div>
            )
          })
        }
      </div>

      <div className={globalStyle.grid6}>
        <h1 className={[globalStyle.heading2, style.header].join(' ')}> Who made this? </h1>
        <div className={globalStyle.bodySM} dangerouslySetInnerHTML={{ __html: data.body?.html || '' }} />
      </div>
    </div>
  );
}

